import Image from 'next/image';

interface Partner {
  id: string;
  src: string;
  alt: string;
  width: number;
  height: number;
  link: string
}

export default function PartnersSection() {
  const partners: Partner[] = [
    { id: '1', src: '/images/seabw.webp', alt: 'SEABW', width: 144, height: 60, link: 'https://seablockchainweek.org/'},
    { id: '2', src: '/images/global-game-show.webp', alt: 'Global Games Show', width: 148, height: 58, link: 'https://www.globalgamesshow.com/' },
    { id: '3', src: '/images/global-blockchain-show.webp', alt: 'global-blockchain-show', width: 152, height: 58, link: 'https://www.globalblockchainshow.com/' },
    { id: '4', src: '/images/eth-dubai.webp', alt: 'eth-dubai', width: 154, height: 46, link: 'https://www.ethdubaiconf.org/' },
    { id: '5', src: '/images/staking-circle.svg', alt: 'staking-circle', width: 190, height: 116, link: 'https://www.stakingcircle.com/' },
  ];

  return (
    <section data-component-id="src/app/PartnersSection.tsx:22:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="22" data-component-end-line="50" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20max-w-%5B1340px%5D%20mx-auto%20px-4%20py-16%20bg-white%20mt-%5B24px%5D%20sm%3Amt-%5B36px%5D%20md%3Amt-%5B0px%5D%22%7D" id='partners' className="w-full max-w-[1340px] mx-auto px-4 py-16 bg-white mt-[24px] sm:mt-[36px] md:mt-[0px]">
      {/* Section Title */}
      <h2 data-component-id="src/app/PartnersSection.tsx:24:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="24" data-component-end-line="26" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B32px%5D%20sm%3Atext-%5B28px%5D%20md%3Atext-%5B48px%5D%20font-instrument%20font-medium%20leading-%5B35px%5D%20sm%3Aleading-%5B38px%5D%20md%3Aleading-%5B42px%5D%20text-center%20text-%5B%23000000%5D%20mb-5%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="text-[32px] sm:text-[28px] md:text-[48px] font-instrument font-medium leading-[35px] sm:leading-[38px] md:leading-[42px] text-center text-[#000000] mb-5">
        Past Partners & Collaborators
      </h2>

      {/* Partners Grid */}
     <div data-component-id="src/app/PartnersSection.tsx:29:5" data-component-path="src/app/PartnersSection.tsx" data-component-line="29" data-component-end-line="48" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-5%20gap-4%20sm%3Agap-6%20md%3Agap-8%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6 md:gap-8">
  {partners.map((partner) => (
    <a data-component-id="src/app/PartnersSection.tsx:31:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="31" data-component-end-line="46" data-component-file="PartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20bg-%5B%23f3f4f6%5D%20rounded-%5B6px%5D%20min-h-%5B100px%5D%20p-4%20sm%3Ap-6%22%7D"
      key={partner.id}
      href={partner.link}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="flex justify-center items-center bg-[#f3f4f6] rounded-[6px] min-h-[100px] p-4 sm:p-6"
    >
      <Image data-component-id="src/app/PartnersSection.tsx:38:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="38" data-component-end-line="45" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20max-h-%5B80px%5D%22%7D"
        src={partner.src}
        alt={partner.alt}
        width={partner.width}
        height={partner.height}
        className="object-contain max-h-[80px]"
        unoptimized
      />
    </a>
  ))}
</div>

    </section>
  );
}
